export default function TransactionMemo(props) {

  return (
    <div className="mb-3">
      <label htmlFor="txMemo" className="form-label">Transaction Memo</label>
      <input type="text" className="form-control" id="txMemo" name="txMemo" value={props.memo} readOnly />
    </div>
  )
}
